module.exports = __webpack_public_path__ + "img/upt.5c12982a.jpg";